import { render, staticRenderFns } from "./PDPComment.vue?vue&type=template&id=d39eeb0a&scoped=true&"
import script from "./PDPComment.vue?vue&type=script&lang=js&"
export * from "./PDPComment.vue?vue&type=script&lang=js&"
import style0 from "./PDPComment.vue?vue&type=style&index=0&id=d39eeb0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39eeb0a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default,PDPCommentNode: require('/app/appsumo/nuxt/components/pdp/comment/PDPCommentNode.vue').default})
